module.exports = __webpack_public_path__ + "static/media/soma9.95910ace.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/ParkingLots/Instructions/SF/soma9.png
// module id = 2225
// module chunks = 0